import amapi from '@/api/amapi'

const initialState = () => ({
  subdomains: [],
  parkedDomains: [],
  redirects: [],
  addonDomains: [],
  domain_records: []
})

const state = initialState

const getters = {
  subdomains: state => state.subdomains,
  parkedDomains: state => state.parkedDomains,
  redirects: state => state.redirects,
  domain_records: state => state.domain_records,
  hostingAddonDomains: state => state.addonDomains.slice()
}

const mutations = {
  SET_HOSTING_SUBDOMAINS: (state, payload) => {
    state.subdomains = payload
  },
  SET_HOSTING_PARKEDDOMAINS: (state, payload) => {
    state.parkedDomains = payload
  },
  SET_HOSTING_REDIRECTS: (state, payload) => {
    state.redirects = payload
  },
  SET_HOSTING_RECORDS: (state, payload) => {
    state.domain_records = payload
  },
  SET_HOSTING_ADDON_DOMAINS: (state, addonDomains) => {
    state.addonDomains = addonDomains
  },
  CLEAR_HOSTING_DOMAIN_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  // load subdomains list
  async getHostingSubdomains ({ commit }, _username) {
    try {
      const data = {
        api2_module: 'SubDomain',
        api2_method: 'listsubdomains',
        _username,
      }

      // const query = await dispatch('cpanel_api2', { ...data })
      const query = await amapi.cpanel_api2({ ...data })
      commit('SET_HOSTING_SUBDOMAINS', query.data)
    } catch (e) {
      throw e
    }
  },

  async getHostingParkedDomains ({ commit }, _username) {
    try {
      const data = {
        api2_module: 'Park',
        api2_method: 'listparkeddomains',
        _username,
      }

      // const query = await dispatch('cpanel_api2', { ...data })
      const query = await amapi.cpanel_api2({ ...data })
      commit('SET_HOSTING_PARKEDDOMAINS', query.data)
    } catch (e) {
      throw e
    }
  },

  async getHostingRedirects ({ commit }, _username) {
    try {
      const data = {
        uapi_module: 'Mime',
        uapi_function: 'list_redirects',
        _username,
      }

      const query = await amapi.cpanel_uapi({ ...data })
      commit('SET_HOSTING_REDIRECTS', query.data)
    } catch (e) {
      throw e
    }
  },

  async getHostingRecords ({ dispatch, commit }, { domain, _username }) {
    try {
      const data = {
        api2_module: 'ZoneEdit',
        api2_method: 'fetchzone_records',
        domain,
        _username,
      }

      const query = await amapi.cpanel_api2({ ...data })
      commit('SET_HOSTING_RECORDS', query.data)
    } catch (e) {
      throw e
    }
  },

  // load addon domains list
  async getHostingAddonDomains ({ dispatch, getters, commit }, _username) {
    try {
      const data = {
        api2_module: 'AddonDomain',
        api2_method: 'listaddondomains',
        _username,
      }
      const response = await amapi.cpanel_api2({ ...data })
      commit('SET_HOSTING_ADDON_DOMAINS', response.data)
    } catch (e) {
      commit('SET_HOSTING_ADDON_DOMAINS', [])
      throw e
    }
  },

  // delete addon domain
  async removeHostingAddonDomain ({ commit, dispatch }, { domain, subdomain, _username }) {
    try {
      const data = {
        api2_module: 'AddonDomain',
        api2_method: 'deladdondomain',
        domain,
        subdomain,
        _username,
      }
      return amapi.cpanel_api2({ ...data })
    } catch (e) {
      throw e
    }
  },

  // create an addon domain
  async addHostingAddonDomain ({ commit, dispatch }, { newdomain, subdomain, _username }) {
    try {
      const data = {
        api2_module: 'AddonDomain',
        api2_method: 'addaddondomain',
        newdomain,
        subdomain,
        _username,
      }
      return amapi.cpanel_api2({ ...data })
    } catch (e) {
      console.log(e)
      throw e
    }
  },

  // change document root
  async changeHostingDomainDocroot ({ dispatch }, { subdomain, rootdomain, dir }) {
    try {
      const data = {
        api2_module: 'SubDomain',
        api2_method: 'changedocroot',
        subdomain,
        rootdomain,
        dir
      }
      return amapi.cpanel_api2({ ...data })
    } catch (e) {
      throw e
    }
  },

  // manage addon domain redirection
  async setHostingDomainRedirection ({ dispatch }, { domain, src = '', redirect, type, redirect_wildcard = '', redirect_www = '', _username }) {
    try {
      const data = {
        uapi_module: 'Mime',
        uapi_function: 'add_redirect',
        domain,
        src,
        redirect,
        type,
        redirect_wildcard,
        redirect_www,
        _username,
      }
      await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },

  // delete addon domain redirection
  async removeHostingDomainRedirection ({ dispatch }, { domain, redirect, _username }) {
    try {
      const data = {
        uapi_module: 'Mime',
        uapi_function: 'delete_redirect',
        domain,
        redirect,
        _username,
      }
      await amapi.cpanel_uapi({ ...data })
    } catch (e) {
      throw e
    }
  },
}

// TODO: on each CRUD action - refresh domains list
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
